// extracted by mini-css-extract-plugin
export default {"layout":"ZirrPage_layout__2IYTK","img":"ZirrPage_img__JYIks"};